import { render, staticRenderFns } from "./BaseFloatingActionButton.vue?vue&type=template&id=41dbe996&"
import script from "./BaseFloatingActionButton.vue?vue&type=script&lang=js&"
export * from "./BaseFloatingActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports